var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es284.js.map
